/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { iccidState } from '../../../helpers/iccidStatus';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CellPhone from 'mdi-material-ui/Cellphone';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import { useDispatch } from 'react-redux';
import IccidActivate from '../../iccid-pools/component/IccidActivate';
import IccidWaitForActivation from '../../iccid-pools/component/IccidWaitForActivation';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import IccidParing from './IccidParing';
import { PlatformIccidPoolNumber } from '../../../interfaces/platform/PlatformIccidPoolNumber';
import { ProductActivatePreActivated } from '../../SimCard/component/ProductActivatePreActivated';

type ImsiSimCardParringOperationType = {
    imsiItem: PlatformIccidPoolNumber;
    reloadPage(): void;
};

export const ImsiSimCardParringOperation: FunctionComponent<ImsiSimCardParringOperationType> = ({ imsiItem, reloadPage }): React.ReactElement => {
    const [simCard, setSimCard] = useState<SimCardInterface | null>(null);
    const dispatch = useDispatch();
    const refreshPage = (): void => reloadPage();

    useEffect(() => {
        const itemLoader = new ItemLoaders(dispatch);
        const loadItems = (): void => {
            if (imsiItem && imsiItem.simCard) {
                itemLoader.getWithCallback(
                    FormGeneralHelper.getByUri(imsiItem.simCard),
                    'sim_card_change_imsi_get',
                    (data: SimCardInterface) => (!data.deleted ? setSimCard(data) : null),
                    {
                        propagateDataToCallback: true,
                        dispatchAfterCallback: false,
                    }
                );
            }
        };
        if (!simCard && imsiItem && imsiItem.simCard) {
            loadItems();
        }
    }, [dispatch, imsiItem, simCard]);

    return (
        <React.Fragment>
            {imsiItem && imsiItem.simCard === null && simCard === null && imsiItem.iccidState === iccidState.FREE && (
                <Card>
                    <CardHeader icon={<CellPhone />} trans="simcard:add.msisdn_parring_with_sim_card" />
                    <CardBody>
                        <IccidParing iccid={imsiItem} refreshPage={refreshPage} />
                    </CardBody>
                </Card>
            )}
            {simCard && !simCard.preActivateState && !simCard.active && simCard.autoactivationdate === null && (
                <Card>
                    <CardHeader icon={<CellPhone />} trans="simcard:add.activate_card_at_mvno" />
                    <CardBody>
                        <IccidActivate iccid={imsiItem} simCard={simCard} refreshPage={refreshPage} />
                    </CardBody>
                </Card>
            )}
            {simCard && !simCard.preActivateState && !simCard.active && simCard.autoactivationdate && (
                <Card>
                    <CardHeader icon={<CellPhone />} trans="simcard:add.activate_card" />
                    <CardBody>
                        <IccidWaitForActivation iccid={imsiItem} simCard={simCard} refreshPage={refreshPage} />
                    </CardBody>
                </Card>
            )}
            {simCard && simCard.preActivateState && !simCard.active && !imsiItem.platformIccidEsim && (
                <Card>
                    <CardHeader icon={<CellPhone />} trans="simcard:add.activate_card_waiting_for_release" />
                    <CardBody></CardBody>
                </Card>
            )}
            {simCard && simCard.preActivateState && !simCard.active && imsiItem.platformIccidEsim && (
                <ProductActivatePreActivated simCard={simCard} reload={refreshPage} />
            )}
        </React.Fragment>
    );
};
